import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from "../../Components/FieldInput"
import Button from "../../Components/Button"
import RasiKattam from "../../Components/RasiKattam"
import AmsaKattam from "../../Components/AmsaKattam"
import { Dropzone, FileMosaic, resizeImage } from "@files-ui/react";
import FieldSelect from "../../Components/FieldSelect"
import FieldMultiSelect from "../../Components/FieldMultiSelect"
import axios from "axios"
import API from '../../Common/API'
import { useHistory } from 'react-router-dom'
// import PreviewRegistration from "./PreviewRegistration"
import { setAlert, setLanguage } from '../../Store/Theme/actions'
import { setZodiacSigns } from '../../Store/Auth/actions'
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
// import LanguageSwitcher from "../../Components/LanguageSwitcher"

// Zodiac sign (Rasi) → corresponding stars (Nakshatras) mapping
// Keys must match exact zodiac names stored in DB
const ZODIAC_STARS_MAP = {
    'Mesham (Aries)':        ['Ashwini','Bharani','Krittika'],
    'Rishabam (Taurus)':     ['Krittika','Rohini','Mrigashirsha'],
    'Mithunam (Gemini)':     ['Mrigashirsha','Ardra','Punarvasu'],
    'Kadagam (Cancer)':      ['Punarvasu','Pushya','Ashlesha'],
    'Simmam (Leo)':          ['Magha','Purva Phalguni','Uttara Phalguni'],
    'Kanni (Virgo)':         ['Uttara Phalguni','Hasta','Chitra'],
    'Thulam (Libra)':        ['Chitra','Swati','Vishakha'],
    'Viruchigam (Scorpio)':  ['Vishakha','Anuradha','Jyeshtha'],
    'Dhanusu (Sagittarius)': ['Mula','Purva Ashadha','Uttara Ashadha'],
    'Magaram (Capricorn)':   ['Uttara Ashadha','Shravana','Dhanishta'],
    'Kumbam (Aquarius)':     ['Dhanishta','Shatabhisha','Purva Bhadrapada'],
    'Meenam (Pisces)':       ['Purva Bhadrapada','Uttara Bhadrapada','Revati'],
}

// Star English → Tamil lookup for print page
export const STAR_TAMIL_MAP = {
    'Ashwini': 'அஸ்வினி', 'Bharani': 'பரணி', 'Karthigai': 'கார்த்திகை',
    'Rohini': 'ரோகிணி', 'Mirugasheersham': 'மிருகசீரிஷம்', 'Thiruvadirai': 'திருவாதிரை',
    'Punarpoosam': 'புனர்பூசம்', 'Poosam': 'பூசம்', 'Ayilyam': 'ஆயில்யம்',
    'Magam': 'மகம்', 'Pooram': 'பூரம்', 'Uthiram': 'உத்திரம்',
    'Hastham': 'அஸ்தம்', 'Chithirai': 'சித்திரை', 'Swathi': 'சுவாதி',
    'Visakam': 'விசாகம்', 'Anusham': 'அனுஷம்', 'Kettai': 'கேட்டை',
    'Moolam': 'மூலம்', 'Pooradam': 'பூராடம்', 'Uthiradam': 'உத்திராடம்',
    'Thiruvonam': 'திருவோணம்', 'Avittam': 'அவிட்டம்', 'Sathayam': 'சதயம்',
    'Purattathi': 'பூரட்டாதி', 'Uthirattathi': 'உத்திரட்டாதி', 'Revathi': 'ரேவதி',
}

// Helper: get stars for a list of zodiac names
const getStarsForZodiacs = (zodiacNames) => {
    const stars = new Set()
    zodiacNames.forEach(name => {
        (ZODIAC_STARS_MAP[name] || []).forEach(s => stars.add(s))
    })
    return Array.from(stars).map(s => ({ text: s, value: s }))
}

const STATIC_FLAWS = [
    { text: 'Raghukethu', value: 'Raghukethu' },
    { text: 'Sevvai', value: 'Sevvai' },
    { text: 'Raghukethu & Sevvai', value: 'Raghukethu & Sevvai' },
    { text: 'Suddha Jathagam', value: 'Suddha Jathagam' },
]
const STATIC_T_FLAWS = [
    { text: 'ராகு கேது', value: 'Raghukethu' },
    { text: 'செவ்வாய்', value: 'Sevvai' },
    { text: 'ராகு கேது & செவ்வாய்', value: 'Raghukethu & Sevvai' },
    { text: 'சுத்த ஜாதகம்', value: 'Suddha Jathagam' },
]
// Flaw value → Tamil text lookup for print page
export const FLAW_TAMIL_MAP = {
    'Raghukethu': 'ராகு கேது',
    'Sevvai': 'செவ்வாய்',
    'Raghukethu & Sevvai': 'ராகு கேது & செவ்வாய்',
    'Suddha Jathagam': 'சுத்த ஜாதகம்',
}
const profileTypes = [{ text: 'Bride', value: 'bride' }, { text: 'Groom', value: 'groom' }]
const tProfileTypes = [{ text: 'மணமகள்', value: 'bride' }, { text: 'மணமகன்', value: 'groom' }]
const yesOrNo = [{ text: "Yes", value: true }, { text: "No", value: false }]
const salaryMode = [{ text: 'Month', value: 'month' }, { text: 'Year', value: 'year' }]
const tYesOrNo = [{ text: "ஆம்", value: true }, { text: "இல்லை", value: false }]
const tSalaryMode = [{ text: "மாதம்", value: true }, { text: "ஆண்டு", value: false }]
const pathams = [{ text: '1-ஆம் பாதம்', value: '1-ஆம் பாதம்' }, { text: '2-ஆம் பாதம்', value: '2-ஆம் பாதம்' }, { text: '3-ஆம் பாதம்', value: '3-ஆம் பாதம்' }, { text: '4-ஆம் பாதம்', value: '4-ஆம் பாதம்' }]
const maritalStatus = [{ text: 'First Marriage', value: 'Never Married' }, { text: 'Divorced', value: 'Divorced' }, { text: 'Widow', value: 'Widow' }, { text: 'Widower', value: 'Widower' },{text:'Seperated',value:'seperated'}]
const tMaritalStatus = [{ text: 'முதல் திருமணம்', value: 'Never Married' }, { text: 'விவாகரத்து பெற்றவர்', value: 'Divorced' }, { text: 'விதவை', value: 'Widow' }, { text: 'மனைவியை இழந்தவன்', value: 'Widower' },{text:"பிரிந்தனர்",value:'seperated'}]
const childOptions = [{ text: "0", value: "0" }, { text: "1", value: "1" }, { text: "2", value: "2" }, { text: "3", value: "3" }, { text: "4", value: "4" }, { text: "5", value: "5" }, { text: 'More than 5', value: 'More than 5' }]

// ── Location data ─────────────────────────────────────────────────────────────
const TN_DISTRICTS = [
    'Ariyalur','Chengalpattu','Chennai','Coimbatore','Cuddalore','Dharmapuri',
    'Dindigul','Erode','Kallakurichi','Kanchipuram','Kanyakumari','Karur',
    'Krishnagiri','Madurai','Mayiladuthurai','Nagapattinam','Namakkal','Nilgiris',
    'Perambalur','Pudukkottai','Ramanathapuram','Ranipet','Salem','Sivaganga',
    'Tenkasi','Thanjavur','Theni','Thoothukudi','Tiruchirappalli','Tirunelveli',
    'Tirupathur','Tiruppur','Tiruvallur','Tiruvannamalai','Tiruvarur','Vellore',
    'Viluppuram','Virudhunagar'
].map(d => ({ text: d, value: d }))

const INDIA_STATES = [
    'Tamil Nadu','Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh',
    'Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala',
    'Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland',
    'Odisha','Punjab','Rajasthan','Sikkim','Telangana','Tripura','Uttar Pradesh',
    'Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi',
    'Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'
].map(s => ({ text: s, value: s }))

// SmartSelect — dropdown with "Other" option that reveals a text input
const SmartSelect = ({ label, value, onChange, options, disabled, error }) => {
    const inList = (v) => options.some(o => o.value === v)
    const [isCustom, setIsCustom] = useState(() => !!(value && options.length > 0 && !inList(value)))

    useEffect(() => {
        if (value && options.length > 0 && !inList(value)) setIsCustom(true)
    }, [value]) // eslint-disable-line

    const base = `rounded-lg border border-borderColor bg-white px-3 py-2.5 text-sm text-tColor focus:border-primeColor focus:outline-none w-full ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`

    if (options.length === 0) {
        return (
            <div className="flex flex-col gap-1">
                <label className="text-sm font-medium text-tColor">{label}</label>
                <input type="text" placeholder={`Enter ${label}`} value={value || ''} disabled={disabled} onChange={e => onChange(e.target.value)} className={base} />
                {error && <p className="text-xs text-red-500 mt-0.5">{error}</p>}
            </div>
        )
    }

    return (
        <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-tColor">{label}</label>
            <select
                value={isCustom ? '__other__' : (value || '')}
                disabled={disabled}
                onChange={e => {
                    if (e.target.value === '__other__') { setIsCustom(true); onChange('') }
                    else { setIsCustom(false); onChange(e.target.value) }
                }}
                className={base}
            >
                <option value="">Select {label}</option>
                {options.map(o => <option key={o.value} value={o.value}>{o.text}</option>)}
                <option value="__other__">Other (type manually)</option>
            </select>
            {isCustom && (
                <input type="text" placeholder={`Type ${label}`} value={value || ''} disabled={disabled} onChange={e => onChange(e.target.value)} className={`${base} mt-1`} />
            )}
            {error && <p className="text-xs text-red-500 mt-0.5">{error}</p>}
        </div>
    )
}

// SectionCard — collapsible accordion card for form sections
const SectionCard = ({ title, open, onToggle, children }) => (
    <div className="rounded-2xl border border-borderColor bg-white shadow-sm overflow-hidden">
        <button
            type="button"
            onClick={onToggle}
            className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-lightGrey/30 transition"
        >
            <p className="text-2xl font-bold text-primeColor">{title}</p>
            <span className={`text-primeColor transition-transform duration-200 ${open ? 'rotate-180' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
            </span>
        </button>
        {open && <div className="px-6 pb-6 pt-2">{children}</div>}
    </div>
)

const initialRegisterForm = {
    profileType: '',
    educationalQualification: '',
    firstName: '',
    lastName: '',
    surname: '',
    tFirstName: '',
    tLastName: '',
    tSurname: '',
    height: '',
    heightInFeet: '',
    occupationDetail: "",
    otherEducationalQualification: "",
    salaryMode: '',
    dateOfBirth: '',
    images: [],
    rasiKattam: [],
    amsaKattam: [],
    password: '',
    birthTime: "",
    birthPlace: "",
    thisaiIruppu: "",
    thisaiIruppuDate: "",
    thisaiIruppuMonth: "",
    thisaiIruppuYear: "",
    maritalStatus: "",
    noOfChild: "",
    childDetails: "",
    confirmPassword: '',
    contactInformation: {
        mobileNumber: '',
        whatsappNumber: '',
        nativeAddress: {
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: 'Tamil Nadu',
            district: '',
            pinCode: ''
        },
        presentAddress: {
            addressLine1: '',
            addressLine2: '',
            district: '',
            city: '',
            state: 'Tamil Nadu',
            pinCode: '',
        },
        isSameAddress: false,
        email: ''
    },
    familyInformation: {
        fatherFirstName: '',
        fatherLastName: '',
        fatherSurname: '',
        motherFirstName: '',
        motherLastName: '',
        motherSurname: '',
        fatherNative: '',
        motherNative: '',
        fatherOccupation: '',
        motherOccupation: '',
        isFatherAlive: true,
        isMotherAlive: true,
        numberOfSibilings: 0,
        numberOfMaleSibilings: 0,
        numberOfFemaleSibilings: 0
    },
    additionalInformation: {
        zodiacSign: '',
        star: '',
        flaws: [],
        padtham:'',
        // ascendant: '',
        expectedZodiacSigns: [],
        expectedStars: [],
        expectedPersonality: [],
        expectedEducationalQualification: '',
        expectedOccupation: '',
        expectedSalary: '',
        expectedStatus: '',
        expectation: ''
    }
}


const CreateUser = ({ compactMode = false, onCreated, onCancel, onActionsReady }) => {

    const [files, setFiles] = React.useState([]);
    const [pType, setPType] = useState()
    const zodiacSignsFromStore = useSelector((state) => state.auth.zodiacSigns)
    const [localZodiacSigns, setLocalZodiacSigns] = useState([])
    const zodiacSigns = zodiacSignsFromStore.length > 0 ? zodiacSignsFromStore : localZodiacSigns
    const flaws = useSelector((state)=>state.auth.flaws)
    const tFlaws = useSelector((state)=>state.auth.tFlaws)
    const [fileUrls, setFileUrls] = useState([])
    const [rasiValues, setRasiValues] = useState([
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);

    const [amsaValues, setAmsaValues] = useState([
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);
    const [stars, setStars] = useState([])
    const status = useSelector((state)=>state.auth.status)
    const tStatus = useSelector((state)=>state.auth.tStatus)
    const allStars = useSelector((state)=>state.auth.allStars)
    const occupation = useSelector((state)=>state.auth.occupation)
    const tOccupation = useSelector((state)=>state.auth.tOccupation)
    const [previewDialog, setPreviewDialog] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const { t } = useTranslation()
    const lang = useSelector((state) => state.theme.language)
    const [screenLoading, setScreenLoading] = useState(false)
    const [heightType, setHeightType] = useState('cm')
    const [childDetails, setChildDetails] = useState(false)
    const [mobileAlreadyExists, setMobileAlreadyExists] = useState(false)
    const [openSections, setOpenSections] = useState({ family: true, contact: true, expected: true })
    const toggleSection = (key) => setOpenSections(s => ({ ...s, [key]: !s[key] }))


    const registerFormSchema = Yup.object().shape({
        profileType: Yup.string().required("Profile type is required"),
        // educationalQualification: Yup.array().required("Educational Qualification is required"),
        firstName: Yup.string().required("First Name is required"),
        // lastName: Yup.string().required("Last Name is required"),
        surname: Yup.string().required("Surname is required"),
        tFirstName: Yup.string().nullable(),
        // tLastName: Yup.string().nullable(),
        profession: Yup.string().nullable(),
        occuapation: Yup.string().nullable(),
        tSurname: Yup.string().nullable(),
        dateOfBirth: Yup.string().required("Date of birth is required"),
        heightInFeet: Yup.string().nullable(),
        height: Yup.number().required("Required"),
        images: Yup.array(),
        rasiKattam: Yup.array(),
        amsaKattam: Yup.array(),
        birthTime: Yup.string().nullable(),
        birthPlace: Yup.string().nullable(),
        thisaiIruppu: Yup.string().nullable(),
        thisaiIruppuDate: Yup.string().nullable(),
        thisaiIruppuMonth: Yup.string().nullable(),
        thisaiIruppuYear: Yup.string().nullable(),
        maritalStatus: Yup.string().nullable(),
        noOfChild: Yup.string().nullable(),
        childDetails: Yup.string().nullable(),
        otherEducationalQualification: Yup.string().nullable(),
        familyInformation: Yup.object().shape({
            fatherFirstName: Yup.string().required("Required"),
            // fatherLastName: Yup.string().required("Required"),
            fatherSurname: Yup.string().required("Required"),
            motherFirstName: Yup.string().required("Required"),
            // motherLastName: Yup.string().required("Required"),
            motherSurname: Yup.string().required("Required"),
            fatherOccupation: Yup.string().nullable(),
            fatherNative: Yup.string().nullable(),
            motherNative: Yup.string().nullable(),
            motherOccupation: Yup.string().nullable(),
            isFatherAlive: Yup.boolean(),
            isMotherAlive: Yup.boolean(),
            numberOfSibilings: Yup.number(),
            numberOfMaleSibilings: Yup.number(),
            numberOfFemaleSibilings: Yup.number(),
            marriedFemaleSiblings: Yup.number(),
            marriedMaleSiblings: Yup.number(),
            siblingsDetails: Yup.string().nullable()
        }),
        contactInformation: Yup.object().shape({
            mobileNumber: Yup.string()
                .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number")
                .required("Mobile number is required"),
            whatsappNumber: Yup.string().nullable(),
            nativeAddress: Yup.object().shape({
                addressLine1: Yup.string().required("Address Line 1 is required"),
                addressLine2: Yup.string().nullable(),
                city: Yup.string().required("City is required"),
                state: Yup.string().required("State is required"),
                district: Yup.string().required("District is required"),
                pinCode: Yup.string().matches(/^[0-9]{6}$/, "Enter a valid 6-digit pincode").required("Pincode is required")
            }),
            presentAddress: Yup.object().shape({
                addressLine1: Yup.string().required("Address Line 1 is required"),
                addressLine2: Yup.string().nullable(),
                city: Yup.string().required("City is required"),
                state: Yup.string().required("State is required"),
                district: Yup.string().required("District is required"),
                pinCode: Yup.string().matches(/^[0-9]{6}$/, "Enter a valid 6-digit pincode").required("Pincode is required")
            }),
            isSameAddress: Yup.boolean(),
            email: Yup.string().nullable(),
        }),
        additionalInformation: Yup.object().shape({
            zodiacSign: Yup.string().required("Required"),
            star: Yup.string().required("Required"),
            flaws: Yup.array(),
            padham: Yup.string().nullable(),
            // ascendant: Yup.string().required("Required"),
            expectedZodiacSigns: Yup.array(),
            expectedStars: Yup.array(),
            expectedPersonality: Yup.array(),
            expectedEducationalQualification: Yup.string().nullable(),
            expectedOccupation: Yup.array(),
            expectedSalary: Yup.string().nullable(),
            expectedStatus: Yup.array(),
            expectation: Yup.string().nullable()
            // password: Yup.string().required("Password is required"),
            // confirmPassword: Yup.string().required("Confirm Password is required"),
        })
    })



    const registerForm = useFormik({
        initialValues: initialRegisterForm,
        validateOnMount: true,
        validationSchema: registerFormSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {

            setSubmitDisabled(true)
            setScreenLoading(true)
            const hfParts = (values.heightInFeet || '').split('.')
            values.heightInFeet = `${hfParts[0] || 0} ft ${hfParts[1] || 0} in`
            values.directApproval = true

            if (mobileAlreadyExists) {
                setSubmitDisabled(false)
                setScreenLoading(false)
                dispatch(setAlert({ type: 'error', title: 'Mobile Number Already Exists', subtitle: 'This mobile number is already registered.', active: true }))
                return;
            }

            // Convert uploaded File objects → [{imageUrl: base64}] for backend storage
            const toBase64 = (file) => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(file)
            })

            let imagesPayload = []
            try {
                imagesPayload = await Promise.all(
                    files
                        .filter(f => f.file instanceof File)
                        .map(async (f) => ({ imageUrl: await toBase64(f.file) }))
                )
            } catch (_) {}

            // Backend reads mobileNumber, email, password at top level.
            // Also include rasiKattam / amsaKattam from local state.
            const payload = {
                ...values,
                mobileNumber: values.contactInformation?.mobileNumber || values.mobileNumber || '',
                email:        values.contactInformation?.email        || values.email        || '',
                password:     values.password || '',
                images:       imagesPayload,
                rasiKattam:   { rasiPlanets: rasiValues },
                amsaKattam:   { amsaPlanets: amsaValues },
            }

            API.post('/user/createUser', payload).then((res) => {
                if (res.status === 200) {
                    dispatch(setAlert({ type: 'success', title: 'User Created', subtitle: 'User profile created successfully.', active: true }))
                    setSubmitDisabled(false)
                    setScreenLoading(false)
                    registerForm.resetForm()
                    if (typeof onCreated === 'function') {
                        onCreated(res.data?.data)
                    }
                }
            }).catch((err) => {
                const msg = err?.response?.data?.error || 'Failed to create user. Please try again.'
                dispatch(setAlert({ type: 'error', title: 'Creation Failed', subtitle: msg, active: true }))
                setSubmitDisabled(false)
                setScreenLoading(false)
            })
        }
    })


    const convertHeight = (cm) => {
        if (!cm) return
        const totalInches = parseFloat(cm) * 0.3937;
        const feet = Math.floor(totalInches / 12);
        const inches = Math.round(totalInches % 12);
        registerForm.setFieldValue('heightInFeet', `${feet}.${inches}`)
    };

    const convertHeightToCm = (feet) => {
        if (!feet) return
        const cm = Math.round(parseFloat(feet) * 30.48);
        registerForm.setFieldValue('height', cm)
    }



    const updateFiles = (incommingFiles) => {
        setFiles(incommingFiles);

        const newUrls = incommingFiles.map((file) => URL.createObjectURL(file.file));
        setFileUrls(newUrls);
        //even your own upload implementation
    };
    const removeFile = (id) => {
        const updatedFiles = files.filter((x) => x.id !== id);
        const removedFileIndex = files.findIndex((file) => file.id === id); //find the index of the removed file

        setFiles(updatedFiles);

        // Remove the corresponding URL
        setFileUrls((prevUrls) => {
            const newUrls = [...prevUrls];
            newUrls.splice(removedFileIndex, 1); // Remove the url at the same index
            return newUrls;
        });
    };

    const getStarsByZodiac = (zodiacId) => {
        // Reset star selection when zodiac changes
        registerForm.getFieldHelpers('additionalInformation.star').setValue('')
        setStars([])
        API.post(`/common/getStarByZodiac`, { zodiacSignId: zodiacId }).then((starRes) => {
            if (starRes.status === 200 && starRes.data.data?.length > 0) {
                setStars(starRes.data.data.map((c) => ({ text: c.starName || c.star, value: c._id })))
            } else {
                // Fallback: use hardcoded map by zodiac name
                const zodiacName = zodiacSigns.find(z => z.value === zodiacId)?.text || ''
                const matched = ZODIAC_STARS_MAP[zodiacName] || []
                setStars(matched.map(s => ({ text: s, value: s })))
            }
        }).catch(() => {
            const zodiacName = zodiacSigns.find(z => z.value === zodiacId)?.text || ''
            const matched = ZODIAC_STARS_MAP[zodiacName] || []
            setStars(matched.map(s => ({ text: s, value: s })))
        })
    }

    const getPresentAddress = (values) => {
        if (values.length === 6) {
            API.get(`/common/getLocationByPincode/${parseInt(values)}`).then((locationRes) => {
                if (locationRes.status === 200) {
                    const location = locationRes.data.data;
                    registerForm.setValues((prevValues) => ({
                        ...prevValues,
                        contactInformation: {
                            ...prevValues.contactInformation,
                            presentAddress: {
                                ...prevValues.contactInformation.presentAddress,
                                city: location.city || prevValues.contactInformation.presentAddress.city,
                                state: location.state || prevValues.contactInformation.presentAddress.state,
                                district: location.district || prevValues.contactInformation.presentAddress.district,
                                pinCode: values  // always keep what the user typed
                            }
                        }
                    }));
                }
            }).catch(() => {});
        } else if (values.length === 0) {
            registerForm.setValues((prevValues) => ({
                ...prevValues,
                contactInformation: {
                    ...prevValues.contactInformation,
                    presentAddress: {
                        ...prevValues.contactInformation.presentAddress,
                        city: '',
                        state: '',
                        district: '',
                        pinCode: ''
                    }
                }
            }));
        }
    };

    const getNativeAddress = (values) => {
        if (values.length === 6) {
            API.get(`/common/getLocationByPincode/${parseInt(values)}`).then((locationRes) => {
                if (locationRes.status === 200) {
                    const location = locationRes.data.data;
                    registerForm.setValues((prevValues) => ({
                        ...prevValues,
                        contactInformation: {
                            ...prevValues.contactInformation,
                            nativeAddress: {
                                ...prevValues.contactInformation.nativeAddress,
                                city: location.city || prevValues.contactInformation.nativeAddress.city,
                                state: location.state || prevValues.contactInformation.nativeAddress.state,
                                district: location.district || prevValues.contactInformation.nativeAddress.district,
                                pinCode: values  // always keep what the user typed
                            }
                        }
                    }));
                }
            }).catch(() => {});
        } else if (values.length === 0) {
            registerForm.setValues((prevValues) => ({
                ...prevValues,
                contactInformation: {
                    ...prevValues.contactInformation,
                    nativeAddress: {
                        ...prevValues.contactInformation.nativeAddress,
                        city: '',
                        state: '',
                        district: '',
                        pinCode: ''
                    }
                }
            }));
        }
    };

    const sameAddress = (e) => {
        const isChecked = e.target.checked;
        registerForm.setValues((prevValues) => ({
            ...prevValues,
            contactInformation: {
                ...prevValues.contactInformation,
                isSameAddress: isChecked,
                nativeAddress: isChecked
                    ? { ...prevValues.contactInformation.presentAddress }
                    : {
                        addressLine1: '',
                        addressLine2: '',
                        city: '',
                        state: '',
                        district: '',
                        pinCode: ''
                    }
            }
        }));
    };
    const translateValues = (value, key, actualValue) => {
        if (lang === 'ta' && key === 'firstName') {
            registerForm.setValues({ ...registerForm.values, firstName: actualValue, tFirstName: value })
        } else if (lang === 'ta' && key === 'lastName') {
            registerForm.setValues({ ...registerForm.values, lastName: actualValue, tLastName: value })
        } else if (lang === 'ta' && key === 'surname') {
            registerForm.setValues({ ...registerForm.values, surname: actualValue, tSurname: value })
        }
    }

    const handleMobileNumber = (values) => {
        if (values.length === 10) {
            API.post(`/common/mobileAlreadyExists`, { mobileNumber: values }).then((valueRes) => {
                const exists = valueRes.data?.data?.exists
                if (exists) {
                    setMobileAlreadyExists(true)
                    dispatch(setAlert({ type: 'error', title: 'Mobile Number Already Exists', subtitle: 'This mobile number is already registered.', active: true }))
                } else {
                    setMobileAlreadyExists(false)
                }
            }).catch(() => {
                // Network/auth error — don't block the form
                setMobileAlreadyExists(false)
            })
        } else {
            setMobileAlreadyExists(false)
        }
    }

    const checkForKids = (values) => {
        if (values !== 'Never Married') {
            setChildDetails(true)
        } else {
            setChildDetails(false)
            registerForm.setFieldValue('noOfChild', '')
            registerForm.setFieldValue('childDetails', '')
        }
    }

    const handleCancel = () => {
        if (typeof onCancel === 'function') {
            onCancel()
            return
        }
        history.goBack()
    }

    useEffect(() => {
        if (zodiacSignsFromStore.length === 0) {
            API.get('/common/getZodiacSign').then((res) => {
                if (res.status === 200 && res.data.data?.length) {
                    const mapped = res.data.data.map((c) => ({ text: c.zodiacSign, value: c._id }))
                    setLocalZodiacSigns(mapped)
                    dispatch(setZodiacSigns(mapped))
                }
            }).catch(() => {})
        }
    }, []) // eslint-disable-line

    useEffect(() => {
        if (typeof onActionsReady === 'function') {
            onActionsReady({
                onCancel: handleCancel,
                onSave: () => registerForm.submitForm(),
                cancelLabel: t('Cancel'),
                saveLabel: t('Save'),
            })
        }

        return () => {
            if (typeof onActionsReady === 'function') {
                onActionsReady(null)
            }
        }
    }, []) // eslint-disable-line

    return (
        <motion.div className={`${compactMode ? 'overflow-visible px-1 pb-8 pt-1' : 'min-h-screen overflow-y-scroll lg:px-10 py-10'} w-full flex flex-col gap-8 registerBg relative`}>
            <motion.div className={`${compactMode ? 'hidden' : 'w-full flex flex-row py-10 px-2 md:px-0 justify-between'}`}>
                <motion.div className="flex flex-row justify-between items-center">
                    {/* <LanguageSwitcher onToggle={(lang) => dispatch(setLanguage(lang))} /> */}
                </motion.div>
            </motion.div>
            {/* Page 1 */}
            <motion.div className="w-full grid grid-cols-1 gap-6">
                <motion.div className="w-full gap-2 flex flex-col justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Basic Information')}</p>
                </motion.div>
                <motion.div className="w-full grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                    <FieldSelect
                        injectClass={'bg-white'}
                        label={t('Bride/Groom')}
                        fieldProps={registerForm.getFieldProps('profileType')}
                        fieldMeta={registerForm.getFieldMeta('profileType')}
                        fieldHelper={registerForm.getFieldHelpers('profileType')}
                        edit={true}
                        dataLoaded={true}
                        options={lang === 'en' ? profileTypes : tProfileTypes}
                        onChange={(ev) => setPType(profileTypes.filter((x) => x.value === ev)[0].text)}
                    />
                    <FieldInput label={t(`Educational Qualification`)} injectClass={'bg-white'} fieldProps={registerForm.getFieldProps('otherEducationalQualification')} fieldHelper={registerForm.getFieldHelpers('otherEducationalQualification')} fieldMeta={registerForm.getFieldMeta('otherEducationalQualification')} edit={true} dataLoaded={true} />
                    <FieldSelect
                        injectClass={'bg-white'}
                        label={t('Marital Status')}
                        fieldProps={registerForm.getFieldProps('maritalStatus')}
                        fieldMeta={registerForm.getFieldMeta('maritalStatus')}
                        fieldHelper={registerForm.getFieldHelpers('maritalStatus')}
                        edit={true}
                        dataLoaded={true}
                        options={lang === 'en' ? maritalStatus : tMaritalStatus}
                        onChange={(ev) => checkForKids(ev)}
                    />
                    {childDetails && <FieldSelect injectClass={'bg-white'} label={t('No of childs')} fieldProps={registerForm.getFieldProps('noOfChild')} fieldHelper={registerForm.getFieldHelpers('noOfChild')} fieldMeta={registerForm.getFieldMeta('noOfChild')} edit={true} dataLoaded={true} options={childOptions} />}
                    {registerForm.values.noOfChild !== "0" && registerForm.values.noOfChild !== '' && registerForm.values.noOfChild !== null && <FieldInput type='textarea' injectClass={'bg-white'} label={'Child Details'} fieldProps={registerForm.getFieldProps('childDetails')} fieldHelper={registerForm.getFieldHelpers('childDetails')} fieldMeta={registerForm.getFieldMeta('childDetails')} edit={true} dataLoaded={true} />}
                </motion.div>
                <motion.div className="w-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} First Name`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tFirstName') : registerForm.getFieldProps('firstName')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tFirstName') : registerForm.getFieldMeta('firstName')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tFirstName') : registerForm.getFieldHelpers('firstName')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'firstName', ev.value)} />
                    {/* <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Last Name`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tLastName') : registerForm.getFieldProps('lastName')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tLastName') : registerForm.getFieldMeta('lastName')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tLastName') : registerForm.getFieldHelpers('lastName')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'lastName', ev.value)} /> */}
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Surname`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tSurname') : registerForm.getFieldProps('surname')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tSurname') : registerForm.getFieldMeta('surname')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tSurname') : registerForm.getFieldHelpers('surname')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'surname', ev.value)} />
                    <FieldInput type="date" dateInjectClass={'bg-white'} label={t(`Date of birth`)} fieldProps={registerForm.getFieldProps('dateOfBirth')} fieldMeta={registerForm.getFieldMeta('dateOfBirth')} fieldHelper={registerForm.getFieldHelpers('dateOfBirth')} edit={true} dataLoaded={true} />
                    {/* <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Height In Cm`)} fieldProps={registerForm.getFieldProps('height')} fieldMeta={registerForm.getFieldMeta('height')} fieldHelper={registerForm.getFieldHelpers('height')} edit={true} dataLoaded={true} onChange={(ev) => convertHeight(ev)} /> */}
                    <motion.div className="flex flex-col gap-2">
                        <label className="font-medium text-sm">{t('Choose height measurement')}</label>

                        <motion.div className="flex items-center gap-4">
                            <label className="flex items-center gap-1">
                                <input
                                    type="radio"
                                    name="heightUnit"
                                    checked={heightType === 'cm'}
                                    onChange={() => setHeightType('cm')}
                                    className="accent-blue-500"
                                />
                                <span>{t('In CM')}</span>
                            </label>

                            <label className="flex items-center gap-1">
                                <input
                                    type="radio"
                                    name="heightUnit"
                                    checked={heightType === 'ft'}
                                    onChange={() => setHeightType('ft')}
                                    className="accent-blue-500"
                                />
                                <span>{t('In Feet')}</span>
                            </label>
                        </motion.div>
                    </motion.div>
                    <FieldInput injectClass={'bg-white'} label={t(`Height In ${heightType === 'cm' ? 'CM' : 'Feet'}`)} fieldProps={heightType === 'cm' ? registerForm.getFieldProps('height') : registerForm.getFieldProps('heightInFeet')}
                        fieldMeta={heightType === 'cm' ? registerForm.getFieldMeta('height') : registerForm.getFieldMeta('heightInFeet')} fieldHelper={heightType === 'cm' ? registerForm.getFieldHelpers('height') : registerForm.getFieldHelpers('heightInFeet')} edit={true} dataLoaded={true} onChange={(ev) => heightType === 'cm' ? convertHeight(ev) : convertHeightToCm(ev)} />
                    <FieldSelect injectClass={'bg-white'} label={t(`Profession`)} fieldProps={registerForm.getFieldProps('profession')} fieldMeta={registerForm.getFieldMeta('profession')} fieldHelper={registerForm.getFieldHelpers('profession')} edit={true} dataLoaded={true} options={lang === 'en' ? occupation : tOccupation} />
                    <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Occupation`)} placeholder="Software Engineer/ Pediatrician/ " fieldProps={registerForm.getFieldProps('occupation')} fieldMeta={registerForm.getFieldMeta('occupation')} fieldHelper={registerForm.getFieldHelpers('occupation')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Occupation Location`)} fieldProps={registerForm.getFieldProps('occupationLocation')} fieldMeta={registerForm.getFieldMeta('occupationLocation')} fieldHelper={registerForm.getFieldHelpers('occupationLocation')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Salary`)} fieldProps={registerForm.getFieldProps('salary')} fieldMeta={registerForm.getFieldMeta('salary')} fieldHelper={registerForm.getFieldHelpers('salary')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t(`${pType ? pType : ''} Salary Mode`)} fieldProps={registerForm.getFieldProps('salaryMode')} fieldMeta={registerForm.getFieldMeta('salaryMode')} fieldHelper={registerForm.getFieldHelpers('salaryMode')} edit={true} dataLoaded={true} options={lang === 'en' ? salaryMode : tSalaryMode} />
                </motion.div>
            </motion.div>
            {/* Page 2 — Family Information */}
            <SectionCard title={t('Family Information')} open={openSections.family} onToggle={() => toggleSection('family')}>
                <div className="w-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father First Name`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherFirstName')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherFirstName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherFirstName')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Surname`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherSurname')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherSurname')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherSurname')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t('Father is alive?')} fieldProps={registerForm.getFieldProps('familyInformation.isFatherAlive')} fieldMeta={registerForm.getFieldMeta('familyInformation.isFatherAlive')} fieldHelper={registerForm.getFieldHelpers('familyInformation.isFatherAlive')} edit={true} dataLoaded={true} options={lang === 'en' ? yesOrNo : tYesOrNo} />
                    <FieldInput injectClass={'bg-white'} label={t(`Father Occupation`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherOccupation')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherOccupation')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherOccupation')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother First Name`)} fieldProps={registerForm.getFieldProps('familyInformation.motherFirstName')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherFirstName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherFirstName')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Surname`)} fieldProps={registerForm.getFieldProps('familyInformation.motherSurname')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherSurname')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherSurname')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t('Mother is alive?')} fieldProps={registerForm.getFieldProps('familyInformation.isMotherAlive')} fieldMeta={registerForm.getFieldMeta('familyInformation.isMotherAlive')} fieldHelper={registerForm.getFieldHelpers('familyInformation.isMotherAlive')} edit={true} dataLoaded={true} options={lang === 'en' ? yesOrNo : tYesOrNo} />
                    <FieldInput injectClass={'bg-white'} label={t(`Mother Occupation`)} fieldProps={registerForm.getFieldProps('familyInformation.motherOccupation')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherOccupation')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherOccupation')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Native`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherNative')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherNative')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherNative')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Native`)} fieldProps={registerForm.getFieldProps('familyInformation.motherNative')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherNative')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherNative')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`No of male siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.numberOfMaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.numberOfMaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.numberOfMaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`No of female siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.numberOfFemaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.numberOfFemaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.numberOfFemaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`No. of female married siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.marriedFemaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.marriedFemaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.marriedFemaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`No. of male married siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.marriedMaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.marriedMaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.marriedMaleSiblings')} edit={true} dataLoaded={true} />
                    <div className="xl:col-span-2">
                        <FieldInput injectClass={'bg-white'} type="textarea" label={t(`Siblings Details`)} fieldProps={registerForm.getFieldProps('familyInformation.siblingsDetails')} fieldHelper={registerForm.getFieldHelpers('familyInformation.siblingsDetails')} fieldMeta={registerForm.getFieldMeta('familyInformation.siblingsDetails')} edit={true} dataLoaded={true} />
                    </div>
                </div>
            </SectionCard>
            {/* Page 3 */}
            <motion.div className="w-full grid grid-cols-1 gap-6">
                <motion.div className="w-full flex gap-2 px-1 flex-col justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Additional Information')}</p>
                </motion.div>
                <motion.div className="w-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldSelect injectClass={'bg-white'} label={t('Zodiac Sign')} fieldProps={registerForm.getFieldProps('additionalInformation.zodiacSign')} fieldMeta={registerForm.getFieldMeta('additionalInformation.zodiacSign')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.zodiacSign')} edit={true} dataLoaded={zodiacSigns.length > 0} options={zodiacSigns} onChange={(ev) => { getStarsByZodiac(ev) }} />
                    <FieldSelect injectClass={'bg-white'} placeholder={t('Star')} label={t(`Star`)} fieldProps={registerForm.getFieldProps('additionalInformation.star')} fieldMeta={registerForm.getFieldMeta('additionalInformation.star')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.star')} edit={true} dataLoaded={true} options={stars} />
                    <FieldSelect injectClass={'bg-white'} placeholder={t('Padham')} label={t(`Padham`)} fieldProps={registerForm.getFieldProps('additionalInformation.padham')} fieldMeta={registerForm.getFieldMeta('additionalInformation.padham')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.padham')} edit={true} dataLoaded={true} options={pathams} />
                    <FieldMultiSelect injectClass={'bg-white'} placeholder={t('Flaws')} label={t(`Flaws`)} fieldProps={registerForm.getFieldProps('additionalInformation.flaws')} fieldMeta={registerForm.getFieldMeta('additionalInformation.flaws')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.flaws')} edit={true} dataLoaded={true} options={lang === 'ta' ? STATIC_T_FLAWS : STATIC_FLAWS} />
                    <div></div>
                </motion.div>
            </motion.div>
            {/* Expected Information accordion */}
            <SectionCard title={t('Expected Information')} open={openSections.expected} onToggle={() => toggleSection('expected')}>
                <div className="w-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Zodiac Sign`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedZodiacSigns')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedZodiacSigns')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedZodiacSigns')} edit={true} dataLoaded={true} options={zodiacSigns}
                        onChange={() => { registerForm.getFieldHelpers('additionalInformation.expectedStars').setValue([]) }}
                    />
                    <FieldMultiSelect injectClass={'bg-white'} label={t('Stars')} fieldProps={registerForm.getFieldProps('additionalInformation.expectedStars')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedStars')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedStars')} edit={true} dataLoaded={true}
                        options={(() => {
                            const selectedZodiacs = registerForm.values.additionalInformation.expectedZodiacSigns || []
                            if (selectedZodiacs.length === 0) return allStars
                            const names = selectedZodiacs.map(id => zodiacSigns.find(z => z.value === id)?.text).filter(Boolean)
                            const filtered = getStarsForZodiacs(names)
                            return filtered.length > 0 ? filtered : allStars
                        })()}
                    />
                    <FieldInput injectClass={'bg-white'} label={t(`Educational Qualification`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedEducationalQualification')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedEducationalQualification')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedEducationalQualification')} edit={true} dataLoaded={true} />
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Profession`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedOccupation')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedOccupation')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedOccupation')} edit={true} dataLoaded={true} options={lang === 'en' ? occupation : tOccupation} />
                    <FieldInput injectClass={'bg-white'} label={t(`Salary`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedSalary')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedSalary')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedSalary')} edit={true} dataLoaded={true} />
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Status`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedStatus')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedStatus')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedStatus')} edit={true} dataLoaded={true} options={lang === 'en' ? status : tStatus} />
                    <FieldInput injectClass={'bg-white'} label={t(`Expectation`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectation')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectation')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectation')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} type="password" label={t(`Password`)} fieldProps={registerForm.getFieldProps('password')} fieldMeta={registerForm.getFieldMeta('password')} fieldHelper={registerForm.getFieldHelpers('password')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} type="password" label={t(`Confirm Password`)} fieldProps={registerForm.getFieldProps('confirmPassword')} fieldMeta={registerForm.getFieldMeta('confirmPassword')} fieldHelper={registerForm.getFieldHelpers('confirmPassword')} edit={true} dataLoaded={true} />
                </div>
            </SectionCard>
            {/* Page 4 — Contact Information */}
            <SectionCard title={t('Contact Information')} open={openSections.contact} onToggle={() => toggleSection('contact')}>
                <div className="flex flex-col gap-6">
                    <div className="w-full grid grid-cols-1 md:grid-cols-3 sm:grid-cols-1 gap-5">
                        <FieldInput injectClass={'bg-white'} type="phone" label={t('Mobile Number')} fieldProps={registerForm.getFieldProps('contactInformation.mobileNumber')} fieldMeta={registerForm.getFieldMeta('contactInformation.mobileNumber')} fieldHelper={registerForm.getFieldHelpers('contactInformation.mobileNumber')} edit={true} dataLoaded={true} onChange={(v) => handleMobileNumber(v)} />
                        <FieldInput injectClass={'bg-white'} type="phone" label={t('Whatsapp Number')} fieldProps={registerForm.getFieldProps('contactInformation.whatsappNumber')} fieldMeta={registerForm.getFieldMeta('contactInformation.whatsappNumber')} fieldHelper={registerForm.getFieldHelpers('contactInformation.whatsappNumber')} edit={true} dataLoaded={true} />
                        <FieldInput injectClass={'bg-white'} placeholder={t('Email')} label={t(`Email`)} fieldProps={registerForm.getFieldProps('contactInformation.email')} fieldMeta={registerForm.getFieldMeta('contactInformation.email')} fieldHelper={registerForm.getFieldHelpers('contactInformation.email')} edit={true} dataLoaded={true} />
                    </div>
                    {/* Present Address */}
                    <div className="rounded-2xl border border-borderColor bg-lightGrey/40 p-5">
                        <div className="mb-5 flex flex-col gap-1">
                            <p className="text-xl font-bold text-primeColor">{t('Present Address')}</p>
                            <p className="text-sm text-tpColor">Enter the current residence address. Pincode auto-fills city, district, and state when available.</p>
                        </div>
                        <div className="grid w-full grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                            <FieldInput injectClass={'bg-white'} label={t(`Pincode`)} ml={true} length={6} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.pinCode')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.pinCode')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getPresentAddress(ev)} />
                            <FieldInput injectClass={'bg-white'} label={t('Address Line 1')} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.addressLine1')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.addressLine1')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.addressLine1')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`Address Line 2`)} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.addressLine2')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.addressLine2')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.addressLine2')} edit={true} dataLoaded={true} />
                            <SmartSelect
                                label={t('State')}
                                value={registerForm.values.contactInformation.presentAddress.state}
                                options={INDIA_STATES}
                                onChange={v => {
                                    registerForm.getFieldHelpers('contactInformation.presentAddress.state').setValue(v)
                                    registerForm.getFieldHelpers('contactInformation.presentAddress.district').setValue('')
                                }}
                                error={registerForm.getFieldMeta('contactInformation.presentAddress.state').touched && registerForm.getFieldMeta('contactInformation.presentAddress.state').error}
                            />
                            <SmartSelect
                                label={t('District')}
                                value={registerForm.values.contactInformation.presentAddress.district}
                                options={registerForm.values.contactInformation.presentAddress.state === 'Tamil Nadu' ? TN_DISTRICTS : []}
                                onChange={v => registerForm.getFieldHelpers('contactInformation.presentAddress.district').setValue(v)}
                                error={registerForm.getFieldMeta('contactInformation.presentAddress.district').touched && registerForm.getFieldMeta('contactInformation.presentAddress.district').error}
                            />
                            <FieldInput injectClass={'bg-white'} label={t(`City`)} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.city')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.city')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.city')} edit={true} dataLoaded={true} />
                        </div>
                        <label className="mt-5 flex w-fit cursor-pointer flex-row items-center gap-3 rounded-full border border-borderColor bg-white px-4 py-3 text-sm font-semibold text-tColor shadow-sm">
                            <input className="h-4 w-4 accent-primeColor" type="checkbox" checked={registerForm.values.contactInformation.isSameAddress} onChange={(ev) => sameAddress(ev)} />
                            <span>{t('Present Address is your native address')}</span>
                        </label>
                    </div>
                    {/* Native Address */}
                    <div className="rounded-2xl border border-borderColor bg-white p-5 shadow-sm">
                        <div className="mb-5 flex flex-col gap-1">
                            <p className="text-xl font-bold text-primeColor">{t('Native Address')}</p>
                            <p className="text-sm text-tpColor">{registerForm.values.contactInformation.isSameAddress ? 'Using present address as native address. Uncheck above to edit separately.' : 'Enter native address details separately when it differs from present address.'}</p>
                        </div>
                        <div className="grid w-full grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                            <FieldInput injectClass={'bg-white'} ml={true} length={6} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`Pincode`)} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.pinCode')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.pinCode')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getNativeAddress(ev)} />
                            <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t('Address Line 1')} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.addressLine1')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.addressLine1')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.addressLine1')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`Address Line 2`)} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.addressLine2')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.addressLine2')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.addressLine2')} edit={true} dataLoaded={true} />
                            <SmartSelect
                                label={t('State')}
                                value={registerForm.values.contactInformation.nativeAddress.state}
                                options={INDIA_STATES}
                                onChange={v => {
                                    registerForm.getFieldHelpers('contactInformation.nativeAddress.state').setValue(v)
                                    registerForm.getFieldHelpers('contactInformation.nativeAddress.district').setValue('')
                                }}
                                disabled={registerForm.values.contactInformation.isSameAddress}
                                error={registerForm.getFieldMeta('contactInformation.nativeAddress.state').touched && registerForm.getFieldMeta('contactInformation.nativeAddress.state').error}
                            />
                            <SmartSelect
                                label={t('District')}
                                value={registerForm.values.contactInformation.nativeAddress.district}
                                options={registerForm.values.contactInformation.nativeAddress.state === 'Tamil Nadu' ? TN_DISTRICTS : []}
                                onChange={v => registerForm.getFieldHelpers('contactInformation.nativeAddress.district').setValue(v)}
                                disabled={registerForm.values.contactInformation.isSameAddress}
                                error={registerForm.getFieldMeta('contactInformation.nativeAddress.district').touched && registerForm.getFieldMeta('contactInformation.nativeAddress.district').error}
                            />
                            <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`City`)} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.city')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.city')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.city')} edit={true} dataLoaded={true} />
                        </div>
                    </div>
                </div>
            </SectionCard>
            <motion.div className="w-full grid grid-cols-1 gap-6">
                <motion.div className="w-full flex px-1 gap-2 flex-col py-5 justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Upload Images and Horoscope Information')}</p>
                </motion.div>
                <motion.div className="h-full">
                    <p className="px-2 text-xl font-bold text-primeColor">{t('Upload Image')}</p>
                    <Dropzone className="relative my-5"
                        onChange={updateFiles}
                        value={files}
                        accept="image/*"
                        maxFiles={5}
                    >
                        {files.map((file) => (
                            <FileMosaic preview={true} key={file.id} {...file} onDelete={removeFile} info />
                        ))}
                    </Dropzone>
                </motion.div>
                <motion.div className="h-full gap-4 w-full flex flex-col">
                    <p className="px-2 text-xl font-bold text-primeColor">{t('Horoscope Chart')}</p>
                    <p className="px-2 text-sm text-tpColor -mt-2">Click any planet button to place it in that house. Each planet can only be in one house at a time.</p>

                    <motion.div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
                        {/* ── ராசி Kattam ── */}
                        <div className="flex flex-col gap-3">
                            <div className="flex items-center gap-2 px-1">
                                <span className="text-base font-bold text-primeColor">ராசி கட்டம்</span>
                                <span className="text-sm text-tpColor">(Rasi Chart)</span>
                            </div>
                            <div className="rounded-2xl border border-borderColor bg-white p-4 shadow-sm">
                                <RasiKattam
                                    setRasiValues={(ev) => setRasiValues(ev)}
                                    rasiValues={rasiValues}
                                    kattamOuterInjectClass="w-full"
                                    kattamInnerInjectclass="min-h-[90px] sm:min-h-[110px]"
                                />
                            </div>
                        </div>

                        {/* ── அம்சம் Kattam ── */}
                        <div className="flex flex-col gap-3">
                            <div className="flex items-center gap-2 px-1">
                                <span className="text-base font-bold text-primeColor">அம்சம் கட்டம்</span>
                                <span className="text-sm text-tpColor">(Amsa Chart)</span>
                            </div>
                            <div className="rounded-2xl border border-borderColor bg-white p-4 shadow-sm">
                                <AmsaKattam
                                    setAmsaValues={(ev) => setAmsaValues(ev)}
                                    amsaValues={amsaValues}
                                    kattamOuterInjectClass="w-full"
                                    kattamInnerInjectclass="min-h-[90px] sm:min-h-[110px]"
                                />
                            </div>
                        </div>
                    </motion.div>

                    {/* Planet legend */}
                    <div className="rounded-xl border border-borderColor bg-slate-50 px-4 py-3 flex flex-wrap gap-x-4 gap-y-1.5">
                        <span className="text-xs font-bold text-slate-500 w-full mb-0.5">Planets / கிரகங்கள்</span>
                        {[
                            ["சூ","Sun / சூரியன்"],["சந்","Moon / சந்திரன்"],["செவ்","Mars / செவ்வாய்"],
                            ["பு","Mercury / புதன்"],["குரு","Jupiter / குரு"],["சுக்","Venus / சுக்கிரன்"],
                            ["சனி","Saturn / சனி"],["ரா","Rahu / ராகு"],["கே","Ketu / கேது"],
                            ["ல","Lagna / லக்னம்"],["மா","Maandi / மாந்தி"],
                        ].map(([abbr, name]) => (
                            <div key={abbr} className="flex items-center gap-1.5">
                                <span className="inline-flex h-6 min-w-[24px] items-center justify-center rounded border border-primeColor/30 bg-primeSoft px-1 text-xs font-bold text-primeColor">{abbr}</span>
                                <span className="text-xs text-slate-600">{name}</span>
                            </div>
                        ))}
                    </div>
                </motion.div>
                {/* Bottom action row — only shown outside SlideOver (compactMode has Save in the header) */}
                {!compactMode && (
                    <motion.div className="w-full flex flex-row justify-end">
                        <motion.div className="w-full max-w-md flex flex-row justify-start rounded-full bg-white p-1 shadow-soft">
                            <Button injectClass={'rounded-full w-full'} type="secondary" onClick={handleCancel}>{t('Back')}</Button>
                            <Button injectClass={'rounded-full w-full'} type="primary" onClick={() => registerForm.submitForm()}>{t('Submit')}</Button>
                        </motion.div>
                    </motion.div>
                )}
            </motion.div>
            {/* <Dialog title="Preview Registration" showDialog={previewDialog} onClose={() => { setPreviewDialog(false); localStorage.removeItem('registerValues') }}>
                <motion.div className={'flex flex-col relative w-full h-full'}>
                    <motion.div className="py-10">
                        <PreviewRegistration registerValues={registerForm.values} />
                    </motion.div>
                    <motion.div className="flex py-2 flex-row w-full items-center absolute inset-x-0 bottom-0 justify-center">
                        <motion.div className={`w-fit ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'} px-2 py-1 rounded-full drop-shadow-lg bg-primeColor text-white`} onClick={() => !submitDisabled && registerForm.submitForm()}>
                            Register
                        </motion.div>
                    </motion.div>
                </motion.div>
            </Dialog > */}
        </motion.div >
    )
}

export default CreateUser
